import { useLocation } from 'react-router-dom';
import { RoutesList } from '@abvehicles/routes/Routes';
import { ConfirmationTemplate } from '@templates';
import { useAbVehiclesStore } from '@abvehicles/store/store';
import { useEffect } from 'react';
import { basename } from '@abvehicles/routes/basename';

export const ConfirmationPage = () => {
  const {
    caseReferenceId,
    resetIssueDetails,
    resetYourDetails,
    wantConfirmationEmail,
  } = useAbVehiclesStore();

  const contentTitle = `What happens next?`;
  const location = useLocation();

  useEffect(() => {
    // push 10 states to history to prevent user from going back to previous pages
    for (let i = 0; i < 10; i++) {
      window.history.pushState(
        { page: i },
        '',
        basename + RoutesList.CONFIRMATION,
      );
    }
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      // Prevent default behavior and navigate to home page
      window.location.replace('https://www.westminster.gov.uk/report-it');
    };

    window.addEventListener('popstate', handlePopState);
    resetIssueDetails();
    resetYourDetails();

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const contentSubtext = (
    <div className="text-bodyLg text-text-body flex flex-col gap-6">
      {wantConfirmationEmail ? (
        <p>A confirmation email will be sent to the email provided shortly.</p>
      ) : (
        <p>
          As you did not leave your contact details you will not receive any
          updates about this report.
        </p>
      )}
      <p>
        {`Your report will be reviewed. Action will be taken if our officers find clear evidence that the vehicle is abandoned.`}
      </p>
    </div>
  );

  const navigationButton = {
    label: 'Return to homepage',
    isExternalLink: true,
    href: 'https://www.westminster.gov.uk/report-it ',
  };

  return (
    <ConfirmationTemplate
      reference={caseReferenceId}
      contentTitle={contentTitle}
      contentSubtext={contentSubtext}
      feedbackLink={true}
      button={navigationButton}
    />
  );
};
